<div class="bg-white rounded-xl shadow-lg p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ title }}</h3>

  <ng-container *ngIf="hasData; else emptyState">

    <!-- Header: total grande + label -->
    <div class="text-center mb-2">
      <p class="text-2xl font-bold text-gray-900">{{ chartData.total | number }}</p>
      <p class="text-sm text-gray-600">{{ totalLabel }}</p>
    </div>

    <!-- Nota de truncamiento (sólo si aplicó Top N) -->
    <p *ngIf="chartData.truncated > 0"
       class="text-xs text-gray-500 text-center mb-2">
      Mostrando Top {{ chartData.labels.length - 1 }} de {{ originalCount | number }}
      <span class="text-gray-400">(resto agrupado en "Otros")</span>
    </p>

    <!-- Gráfico de barras -->
    <app-bar-chart [config]="chartConfig"></app-bar-chart>

  </ng-container>

  <ng-template #emptyState>
    <div class="h-64 flex items-center justify-center text-gray-400">
      <div class="text-center">
        <i class="fas {{ emptyIcon }} text-3xl mb-2"></i>
        <p class="text-sm">{{ emptyText }}</p>
      </div>
    </div>
  </ng-template>
</div>
